export const preloadPercentage = (state) =>
  (Object.keys(state.preloadStatus).reduce(
    (sum, key) => ((state.preloadStatus[key].status || '').includes('Success', 'Failed') ? sum + 1 : sum),
    0
  ) /
    4) *
  100;
